import { render, staticRenderFns } from "./svgaImg.vue?vue&type=template&id=3b686f58&scoped=true&"
import script from "./svgaImg.vue?vue&type=script&lang=ts&"
export * from "./svgaImg.vue?vue&type=script&lang=ts&"
import style0 from "./svgaImg.vue?vue&type=style&index=0&id=3b686f58&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b686f58",
  null
  
)

export default component.exports